<template>

  <b-card
    no-body
    class="mb-1 border-0">
    <b-card-header
      header-tag="header"
      class="py-3 px-4 pointer border-0"
      role="tab"
      v-b-toggle="`${list.list_id}-${client_id}`">
      <div class="d-flex flex-row justify-content-between align-items-center">

        <div class="d-flex align-items-center">

          <div>
            <i class="fas fa-sort-down mr-3"></i>
            <span>{{list.list_name}}</span>
          </div>

          <!--<div>-->
            <!--<b-button-->
              <!--:id="`shortcode-${list.list_id}`"-->
              <!--size="sm"-->
              <!--class="ml-2"-->
              <!--@click.stop="copyShortcodeToClipboard"-->
              <!--variant="outline-secondary"-->
            <!--&gt;-->
              <!--{{$t('button.copy_shortcode')}}-->
            <!--</b-button>-->

            <!--<b-tooltip-->
              <!--:target="`shortcode-${list.list_id}`"-->
              <!--triggers="hover"-->
              <!--:title="$t('resources.tooltip_copy_shortcode')"-->
              <!--placement="top"-->
            <!--&gt;</b-tooltip>-->
          <!--</div>-->

        </div>

        <div>
          <b-badge
            :variant="params.allowed_list ? 'success': 'info'"
            class="text-white ml-2 font-weight-light"
            style="font-size: 12px">
            {{params.allowed_list ? $t('global.allowed') : $t('global.disallowed')}}
          </b-badge>
          <b-badge
            :variant="params.require_list ? 'success': 'info'"
            class="text-white ml-2 font-weight-light"
            style="font-size: 12px">
            {{params.require_list ? $t('resources.forced') : $t('resources.optional')}}
          </b-badge>
          <b-badge
            :variant="params.show_list ? 'success' : 'info' "
            class="text-white ml-2 font-weight-light"
            style="font-size: 12px">
            {{params.show_list ? $t('resources.shown') : $t('resources.hidden') }}
          </b-badge>
        </div>

      </div>
    </b-card-header>

    <b-collapse
      :visible="open"
      :id="`${list.list_id}-${client_id}`"
      accordion="my-accordion"
      role="tabpanel">

      <b-card-body class="px-4 pb-0">

        <b-row class="mb-3">

          <b-col class="mb-3" lg="4">
            <b-form-checkbox
              @input="triggerUpdate"
              :disabled="list.confirmed_opt"
              type="checkbox"
              v-model="params.require_list"
            >
              {{$t('resources.required_list')}}

              <p v-if="list.confirmed_opt"
                 class="text-muted small">
                {{$t('resources.email_conf_required')}}
                <i :id="`email-${list.list_id}`" class="fas fa-question-circle"></i>
              </p>
              <b-tooltip
                v-if="list.confirmed_opt"
                :target="`email-${list.list_id}`"
                triggers="hover"
                :title="$t('resources.email_conf_tooltip')"
                placement="top"
              ></b-tooltip>

            </b-form-checkbox>
          </b-col>

          <b-col class="mb-3" lg="4">
            <b-form-checkbox
              @input="triggerUpdate"
              type="checkbox"
              v-model="params.show_list"
            >{{$t('resources.show_list')}}
            </b-form-checkbox>
          </b-col>

          <b-col class="mb-3" lg="4">
            <b-form-checkbox
                    @input="triggerUpdate"
                    type="checkbox"
                    v-model="params.allowed_list">
              {{$t('resources.available_list')}}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mb-3">

          <b-col lg="12"
                 v-if="!!wallkit_fields.length && !!campaign_monitor_fields.length">

            <b-row v-if="!!params.sync_fields.length" v-for="(param, index) in params.sync_fields" :key="index"
                   class="align-items-end mb-4">

              <b-col>
                <div class="position-relative">
                  <label class="d-block">{{$t('event.wallkit_field')}}</label>
                  <!--{{params.sync_fields[index]}}-->
                  <multiselect
                    v-model="params.sync_fields[index].wallkit"
                    @select="triggerUpdate"
                    deselectLabel="X"
                    selectLabel=""
                    selectedLabel=""
                    :multiple="false"
                    :options="wallkit_fields"
                    :searchable="true"
                    :allow-empty="true">
                    <template slot="noResult">
                      {{$t('global.no_results')}}
                    </template>
                  </multiselect>
                </div>
              </b-col>

              <b-col>
                <div class="position-relative">
                  <label class="d-block">{{$t('resources.campaignmonitor_field')}}</label>
                  <!--{{params.sync_fields[index]}}-->
                  <multiselect
                    v-model="params.sync_fields[index].campaign_monitor"
                    @select="triggerUpdate"
                    deselectLabel="X"
                    selectLabel=""
                    :multiple="false"
                    :options="campaign_monitor_fields"
                    label="label"
                    track-by="label"
                    :searchable="false"
                    :allow-empty="true">
                    <template slot="noResult">
                      {{$t('global.no_results')}}
                    </template>
                  </multiselect>
                </div>
              </b-col>

              <b-col md="1" class="d-flex justify-content-end">
                <b-button
                  @click="() => {deleteItemByIndex(params.sync_fields, index);triggerUpdate()}"
                  variant="outline-primary"
                  size="sm"
                  style="height: 34px; width: 34px"
                >
                  <i class="fas fa-trash fa-lg"></i>
                </b-button>
              </b-col>

            </b-row>

            <div class="w-100 d-flex justify-content-end">
              <b-button
                @click="addReactiveItemToArray(params.sync_fields, {wallkit: '', campaign_monitor: ''})"
                variant="outline-primary"
                size="sm"
                style="height: 34px; width: 34px;"
              >
                <i class="fas fa-plus fa-lg"></i>
              </b-button>
            </div>
          </b-col>

          <b-col v-else lg="8">
            <p class="text-muted text-center">{{$t('resources.no_sync_field')}}</p>
          </b-col>

        </b-row>

      </b-card-body>

    </b-collapse>
  </b-card>

</template>

<script>
  import {pick} from 'lodash';
  import {inviteMethods} from '@/mixins/invite';

  export default {
    name: 'CampaignMonitorList',
    props: {
      list: {
        type: Object
      },
      wallkit_fields: {
        type: Array
      },
      sync_fields: {
        type: Array
      },
      client_id: {
        type: String
      },
      open: {
        type: Boolean,
        default: false
      }
    },
    mixins: [inviteMethods],
    data() {
      return {
        campaign_monitor_fields: [],
        params: {},
      }
    },
    created() {
      this.prefillList();

    },
    methods: {
      prefillList() {
        this.params = pick(this.list, ['list_id', 'show_list', 'require_list', 'allowed_list']);

        if (!!this.sync_fields.length) {
          this.params.sync_fields = this.sync_fields.filter(field => {
            return field.campaign_monitor && field.wallkit;
          });
        } else {
          this.params.sync_fields = [{wallkit: '', campaign_monitor: ''}];
        }

        this.list.cm_fields.map((field) => {
          this.campaign_monitor_fields.push({label: field.FieldName, value: field.Key});
        });
      },
      triggerUpdate() {
        this.$emit('update', {data: this.params, key: this.list.list_id});
        this.$forceUpdate();
      },
      copyShortcodeToClipboard() {
        const text =
            `<b-form-checkbox
                 id="${this.list.list_id}"
                 type="checkbox"
                 v-model="template.form.lists.${this.list.list_id}"
                >${this.list.list_name}</b-form-checkbox>`;
        this.copyDataToClipboard(text, true);
      }
    },
  }
</script>
